import { standardApiHandler } from "../../../core/core-api/apiTools";
import { featureInfoAdapter } from "./featureInfo.adapter";
import { Feature } from "../../../core/geo/types";

export type FeatureInfoServiceParams = { url: string };
export type FeatureInfoServiceResponse = { features: Feature[] };

export type FeatureInfoService = (params: FeatureInfoServiceParams) => Promise<FeatureInfoServiceResponse>;
export const featureInfoService: FeatureInfoService = standardApiHandler(featureInfoAdapter);
